import { render, staticRenderFns } from "./homefire-policy-holder-form.vue?vue&type=template&id=0a4e6cc2&scoped=true&"
import script from "./homefire-policy-holder-form.vue?vue&type=script&lang=js&"
export * from "./homefire-policy-holder-form.vue?vue&type=script&lang=js&"
import style0 from "./homefire-policy-holder-form.vue?vue&type=style&index=0&id=0a4e6cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e6cc2",
  null
  
)

export default component.exports